const featurePT = {
    "view": {
        "table": {
            "title": "Solicitações de Recurso",
            "column": {
                "release_name": "Nome",
                "release_artist_name": "Nome do Artista do Lançamento",
                "release_date": "Data de Lançamento",
                "exclusive_date": "Data Exclusiva"
            },
            "button": {
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Pesquisar..."
            }
        },
        "message": {
            "subscriptionUpgrade": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para aproveitar este recurso.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>retome</1> sua assinatura para aproveitar este recurso.",
            "noAccess": "Você não tem acesso a este módulo, por favor, entre em contato com a equipe de suporte para mais informações."
        }
    },
    "add": {
        "title": "Fatos de Marketing",
        "form": {
            "label": {
                "release": "Lançamento",
                "djTastemaker": "Feedbacks de DJ / Influenciador:",
                "radioSupport": "Suporte de Rádio",
                "marketingPR": "Marketing / PR",
                "labelReach": "Alcance do Selo e Artistas:"
            },
            "help_text": {
                "release": "Selecione um lançamento para o qual você deseja enviar uma solicitação de destaque. Você só pode ver e selecionar lançamentos que tenham uma data de lançamento geral 22 ou mais dias à frente. Se você estiver visando uma data de lançamento exclusiva, certifique-se de enviar este formulário pelo menos 22 dias antes de uma (primeira) data de lançamento exclusiva.",
                "djTastemaker": "Insira 10 feedbacks de DJ / Rádio / Revista no formato 'Nome - Feedback' (Insira cada feedback em uma linha). Submissões contendo 'baixando para' não serão promovidas ou enviadas para lojas online.",
                "radioSupport": "Sua música ou lançamento está sendo destaque em algumas estações de rádio? Se sim, nomeie a estação e insira o link correspondente para a página deles onde é visível que estão promovendo ou tocando suas músicas.",
                "marketingPR": "(Entrevistas, blogs, resenhas, artigos de revista) - Por favor, liste todas as atividades de imprensa e marketing comprometidas para este lançamento. Não é obrigatório, mas essencialmente importante para se destacar da concorrência.",
                "labelReach": "A quantidade combinada (selo e artistas) de seguidores no Facebook, Instagram, SoundCloud e YouTube. <strong>Por favor, coloque cada plataforma e número de seguidores em uma nova linha</strong>."
            },
            "button": {
                "submit": "Enviar"
            },
            "message": {
                "releaseRequired": "Lançamento existente é necessário",
                "featureRequestAlreadyExists": "Solicitação de recurso para este lançamento já foi feita"
            }
        },
        "message": {
            "success": "Solicitação de recurso foi adicionada!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        },
        "modal": {
            "confirm": {
                "header": "Nova solicitação de recurso",
                "body": "Esta solicitação de recurso deve ser enviada pelo menos 21 dias antes da primeira data (exclusiva ou geral, o que vier primeiro). Infelizmente, submissões tardias não podem ser consideradas. Você deseja enviar sua solicitação de recurso?"
            }
        }
    }
};

export default featurePT;